import { render, staticRenderFns } from "./DangKyChuongTrinhKichCauForm.vue?vue&type=template&id=f3986682"
import script from "./DangKyChuongTrinhKichCauForm.vue?vue&type=script&lang=js"
export * from "./DangKyChuongTrinhKichCauForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports